import { Component, OnInit } from '@angular/core';
import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-logout-redirect',
  imports: [TranslocoModule],
  template: `
    <p>
      {{ "login.logout-redirect-message" | transloco }}...
    </p>
  `,
  styles: ``,
  standalone: true,
  providers: [provideTranslocoScope('login')],
})
export class LogoutRedirectComponent implements OnInit {
  ngOnInit(): void {
    broadcastResponseToMainFrame().catch((error) => {
      console.error("Error broadcasting to main frame", error);
    });
  }
}
